import { render, staticRenderFns } from "./UserSelectDialog.vue?vue&type=template&id=65040209&"
import script from "./UserSelectDialog.vue?vue&type=script&lang=js&"
export * from "./UserSelectDialog.vue?vue&type=script&lang=js&"
import style0 from "./UserSelectDialog.vue?vue&type=style&index=0&lang=css&"
import style1 from "./UserSelectDialog.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\GTHB03-CV-02\\_work\\sb\\sb\\mvc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65040209')) {
      api.createRecord('65040209', component.options)
    } else {
      api.reload('65040209', component.options)
    }
    module.hot.accept("./UserSelectDialog.vue?vue&type=template&id=65040209&", function () {
      api.rerender('65040209', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "SPHEREboardMVC/wwwroot/vue/components/UserSelectDialog.vue"
export default component.exports